<template>
  <div class="container page" style="background-color: #1f1c1f;">
    <van-nav-bar :title="$t('setting.language')" class="nav-bar">
      <template #left><van-icon name="arrow-left" color="#fff" @click="back" /></template>
    </van-nav-bar>
    <div class="items">
      <div v-for="item in languages" :key="item.code" class="item van-hairline--bottom" @click="changeLang(item.code)">
        <div class="flex_center">
          <img :src="item.flag" alt="" class="lang_flag" />
          <div class="info">{{ $t(item.label) }}</div>
        </div>
        <div v-if="lang === item.code">✓</div>
      </div>
    </div>
  </div>
</template>

<script>
import { Toast } from 'vant';

export default {
  name: 'Language',
  data() {
    return {
      lang: localStorage.getItem('lang') || this.$i18n.locale || 'ja',
      source: '',
      languages: [
        { code: 'ja', label: 'lang.ja', flag: '/img/ja.png' },
        { code: 'en', label: 'lang.en', flag: '/img/en.png' },
        { code: 'es', label: 'lang.es', flag: '/img/es.png' }
      ]
    };
  },
  mounted() {
    this.source = this.$route.params.type || '';
  },
  methods: {
    back() {
      window.history.back();
    },
    replaceLang() {
      return this.$http({ method: 'get', url: 'replaceLang', data: { lang: this.lang } });
    },
    changeLang(lang) {
      Toast.loading({ duration: 200 });
      this.lang = lang;
      this.$i18n.locale = lang;
      localStorage.setItem('lang', lang);
      localStorage.setItem('lang_source', 'manual');
      document.documentElement.lang = lang;
      this.replaceLang().finally(() => {
        this.$router.replace(this.source === 'setting' ? { path: '/Mine' } : { path: '/' });
      });
    }
  }
};
</script>

<style lang="less" scoped>
@import "../../assets/css/base.css";
.nav-bar { background: #1f1c1f; height: 100px; }
.container .items { background: linear-gradient(120deg, #212121, #313131); font-size: 30px; color: #f3c7a2; padding: 25px; }
.container .items .item { padding: 20px 0; display: flex; justify-content: space-between; align-items: center; border-bottom-width: 10px; }
.flex_center { display: flex; align-items: center; }
.flex_center img.lang_flag { width: 60px; height: 40px; object-fit: cover; margin-right: 20px; border-radius: 4px; }
</style>
